import { Checkbox as UiKitCheckbox } from '@idaho-aeyc/ui-kit';
import { TCheckboxProps } from './Checbox.types';

const Checkbox = (props: TCheckboxProps) => {
  return <UiKitCheckbox {...props} />;
};

export default Checkbox;
